<!--===============================
=            CAROUSELS            =
================================-->

<template>
  <!-- carousels -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Carousels</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <!-- carousels -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Playground
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <v-row justify="space-around">
                <v-icon @click="model--">mdi-minus</v-icon>
                {{ model }}
                <v-icon @click="model++">mdi-plus</v-icon>
              </v-row>
              <v-row justify="space-around">
                <v-switch v-model="showArrows" label="Show arrows"></v-switch>
                <v-switch v-model="hideDelimiters" label="Hide delimiters"></v-switch>
                <v-switch v-model="cycle" label="Cycle"></v-switch>
              </v-row>
              <v-carousel
                v-model="model"
                :show-arrows="showArrows"
                :hide-delimiters="hideDelimiters"
                :cycle="cycle"
              >
                <v-carousel-item v-for="(color, i) in colors" :key="color">
                  <v-sheet :color="color" height="100%" tile>
                    <v-row class="fill-height" align="center" justify="center">
                      <div class="display-3">Slide {{ i + 1 }}</div>
                    </v-row>
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- carousels -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Cycle</div>
          <div slot="card-body">
            <div>
              <v-carousel cycle height="400" hide-delimiter-background show-arrows-on-hover>
                <v-carousel-item v-for="(slide, i) in slides" :key="i">
                  <v-sheet :color="colors[i]" height="100%">
                    <v-row class="fill-height" align="center" justify="center">
                      <div class="display-3">{{ slide }} Slide</div>
                    </v-row>
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- carousels -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Custom transition</div>
          <div slot="card-body">
            <v-carousel class>
              <v-carousel-item
                v-for="(item,i) in items"
                :key="i"
                :src="item.src"
                max-width="944"
                reverse-transition="fade-transition"
                transition="fade-transition"
              ></v-carousel-item>
            </v-carousel>
          </div>
        </base-card>
      </v-col>

      <!-- carousels -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Custom delimiters</div>
          <div slot="card-body">
            <v-card elevation="24" max-width="444" class="mx-auto">
              <v-system-bar lights-out></v-system-bar>
              <v-carousel
                :continuous="false"
                :cycle="cycle"
                :show-arrows="false"
                hide-delimiter-background
                delimiter-icon="mdi-minus"
                height="300"
              >
                <v-carousel-item v-for="(slide, i) in slides" :key="i">
                  <v-sheet :color="colors[i]" height="100%" tile>
                    <v-row class="fill-height" align="center" justify="center">
                      <div class="display-3">{{ slide }} Slide</div>
                    </v-row>
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>
              <v-list two-line>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-img src="https://cdn.vuetifyjs.com/images/john.png"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>John Leider</v-list-item-title>
                    <v-list-item-subtitle>Author</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-switch v-model="cycle" label="Cycle Slides" inset></v-switch>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <!-- carousels -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Hide controls</div>
          <div slot="card-body">
            <div>
              <v-carousel :show-arrows="false">
                <v-carousel-item max-width="960" v-for="(item,i) in items" :key="i" :src="item.src"></v-carousel-item>
              </v-carousel>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- carousels -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Hide delimiters</div>
          <div slot="card-body">
            <div>
              <v-carousel hide-delimiters>
                <v-carousel-item max-width="960" v-for="(item,i) in items" :key="i" :src="item.src"></v-carousel-item>
              </v-carousel>
            </div>
          </div>
        </base-card>
      </v-col>

      <!-- carousels -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">v-model control</div>
          <div slot="card-body">
            <div>
              <v-row justify="space-around">
                <v-icon @click="model--">mdi-minus</v-icon>
                {{ model }}
                <v-icon @click="model++">mdi-plus</v-icon>
              </v-row>
              <v-carousel v-model="model">
                <v-carousel-item v-for="(color, i) in colors" :key="color">
                  <v-sheet :color="color" height="100%" tile>
                    <v-row class="fill-height" align="center" justify="center">
                      <div class="display-3">Slide {{ i + 1 }}</div>
                    </v-row>
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  data() {
    return {
      colors: ["pink", "deep-purple", "yellow darken-2", "red", "orange"],
      model: 0,
      showArrows: true,
      hideDelimiters: false,
      cycle: false,
      items: [
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg"
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg"
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg"
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg"
        }
      ],
      slides: ["purple", "deep-purple", "yellow darken-2", "red", "orange"]
    };
  }
};
</script>
<style>
.textt {
  overflow: hidden;
  font-size: 12px;
  overflow: hidden !important;
  max-width: auto;
  max-height: 28px;
  text-overflow: ellipsis;
  line-height: 14px !important;
  white-space: inherit;
  vertical-align: top;

  word-wrap: break-word;
  align-items: center;
}

.card_tittle {
  line-height: 1 !important;
}

.space-around {
  border-radius: 50%;
}

.mdi:before,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  border-radius: 50%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.v-btn__content {
  border-radius: 50%;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: inherit;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  -webkit-box-pack: inherit;
  -ms-flex-pack: inherit;
  justify-content: inherit;
  line-height: normal;
  position: relative;
}

.v-btn__content {
  align-items: center;
  color: inherit;
  display: flex;
  flex: 1 0 auto;
  justify-content: inherit;
  line-height: normal;
  position: relative;
}

*,
::after,
::before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>

<!--====  End of CAROUSELS  ====-->